import { YoutubeVideo } from '@/molecules';
import VimeoVideo from '@/molecules/vimeo-video';

import type { FunctionComponent } from 'react';
import type { TypeVideoProps } from './types';

/**
 * Video
 */
export const Video: FunctionComponent<TypeVideoProps> = ({
  className,
  type,
  videoId,
}: TypeVideoProps) =>
  type === 'youtube' ? (
    <YoutubeVideo videoId={videoId} {...(className && { className })} />
  ) : (
    <VimeoVideo videoId={videoId} {...(className && { className })} />
  );

Video.displayName = 'Video';
